import React, { useState } from "react";
import Header from "../Components/Dashboard/Header";
import SideBar from "../Components/Dashboard/SideBar";
import "./PageLayout.css";

const PageLayout = ({ children }) => {
  const [openSidebar, setOpenSidebar] = useState(false);

  return (
    <div className="page-container">
      <Header isSidebarOpen={openSidebar} handleSidebar={setOpenSidebar} />
      <div className="main-container">
        <aside className={openSidebar ? "" : "hidden-sidebar"} >
          <SideBar handleSidebar={setOpenSidebar} />
        </aside>
        <main className="main-content main-align">{children}</main>
      </div>
    </div>
  );
};

export default PageLayout;
